import React, { type JSX } from 'react';
import Radio from '../Radio';
import { Control } from 'react-hook-form';

type IRadioLineProps = {
  handleChecked?: React.ChangeEventHandler<HTMLInputElement>;
  value: string;
  checked?: boolean;
  children: React.ReactNode;
  isVerticallyCentered?: boolean;
  id: string;
  required?: boolean;
  more?: JSX.Element;
  disabled?: boolean;
  isTextBoldWhenChecked?: boolean;
  dataTestId?: string;
  withLowOpacityWhenDisabled?: boolean;
  name: string;
  control?: Control;
  isBackgroundColoredWhenChecked?: boolean;
};

const RadioLine: React.FC<IRadioLineProps> = ({
  handleChecked,
  value,
  checked,
  children,
  isVerticallyCentered,
  id,
  control,
  required = false,
  disabled = false,
  name,
  more,
  isTextBoldWhenChecked = false,
  dataTestId,
  withLowOpacityWhenDisabled = false,
  isBackgroundColoredWhenChecked = true,
}) => (
  <>
    <label htmlFor={id} data-testid={dataTestId}>
      <div className="radio-container">
        <Radio
          onChange={handleChecked}
          id={id}
          name={name}
          control={control}
          required={required}
          value={value}
          checked={checked}
          disabled={disabled}
        />
      </div>
      <span className="label">{children}</span>
      {more && <span className="more">{more}</span>}
    </label>
    <style jsx>{`
      label {
        display: flex;
        padding: var(--space-3);
        align-items: ${isVerticallyCentered ? 'center' : 'flex-start'};
        justify-content: flex-start;
        cursor: ${disabled ? 'not-allowed' : 'pointer'};
        opacity: ${disabled && withLowOpacityWhenDisabled ? '0.5' : '1'};

        ${checked && isBackgroundColoredWhenChecked
          ? `
          background-color: var(--clr-primary-5);
          border-radius: var(--rd-2);
        `
          : ''}
      }

      .radio-container {
        display: inline-block;
        margin-right: var(--space-5);
        min-width: 24px;
        max-width: 24px;
        height: 24px;
      }

      .radio-container :global(input + div) {
        width: 24px !important;
        height: 24px !important;
      }

      label .label {
        width: 100%;
        align-self: center;
        ${checked && isTextBoldWhenChecked ? 'font-weight: bold;' : ''}
      }

      .more {
        margin-left: var(--space-3);
      }
    `}</style>
  </>
);

export default RadioLine;
